export function getCurrentPathname(state: any) {
    return state.router.location.pathname;
}
